import { router } from "@inertiajs/vue3";
import { onMounted, onUnmounted, ref } from "vue";

export const useFbTracking = () => {
    const cleanupFn = ref(() => {});
    onMounted(() => {
        const key = "fbclid";
        const param = new URL(window.location.href).searchParams.get(key);
        if (param && !localStorage.getItem(key)) localStorage.setItem(key, param);

        if (localStorage.getItem(key)) {
            cleanupFn.value = router.on("navigate", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ fbclid: localStorage.getItem(key) });
            });
        }
    });

    onUnmounted(() => cleanupFn.value());
};
